// Colored bottom banner that flags non-production (staging/test) instances.
//
// Whether it shows — and with what label/color — is decided server-side from the
// container's PLATFORM_ENV (see avs_platform/boot.py). This script only renders.
//
// Loaded on the desk via app_include_js and on website/login pages via web_include_js.
// On the desk the descriptor is already in frappe.boot.platform_env; guests (login
// page) have no boot, so we fall back to a cached guest-allowed call.
//
// It sits at the BOTTOM on purpose. A top banner has to push the whole desk down,
// which means shifting every rule derived from --navbar-height: the sticky .navbar,
// .page-head, .form-tabs-sticky-up/-down, and the `height: calc(100vh - ...)` of
// .layout-main. Missing one clips the header or the sidebar, and each ERPNext upgrade
// can add another. Anchoring to the bottom touches none of that stack.
//
// Space below the content is reserved by a spacer div appended as the LAST flow
// element of <body> — NOT by body padding. Frappe's common/global.scss pins
// `html, body { height: 100% }` (border-box), so the desk content overflows the
// body box and the document scroll height comes from that overflow: bottom padding
// on body lands mid-document and reserves nothing. A flow spacer, by contrast, is
// laid out after the overflowing content and extends the scroll height, so at full
// scroll the fixed banner covers only the empty spacer, never the content (e.g.
// list-view pagination). Workspaces scroll inside .layout-main instead of the
// document; there the inner scrollers get padding-bottom so their content can
// scroll clear of the banner.

(() => {
	const BANNER_ID = "avs-platform-env-banner";
	const STYLE_ID = "avs-platform-env-style";
	const H = 28; // banner height in px

	function render(info) {
		if (!info || !info.label) return;
		if (document.getElementById(BANNER_ID)) return; // idempotent

		const color = info.color || "#d9534f";

		// See the header comment: the spacer (last flow element of <body>) reserves
		// the strip below the content; body padding cannot (height-pinned body).
		const style = document.createElement("style");
		style.id = STYLE_ID;
		style.textContent =
			`#${BANNER_ID}-spacer { height: ${H}px; }` +
			`[data-page-route="Workspaces"] .layout-side-section,` +
			`[data-page-route="Workspaces"] .layout-main-section-wrapper` +
			`{ padding-bottom: ${H}px; }` +
			`#${BANNER_ID}{position:fixed;bottom:0;left:0;right:0;height:${H}px;` +
			`line-height:${H}px;z-index:2000;text-align:center;font-size:12px;` +
			`font-weight:600;letter-spacing:.5px;text-transform:uppercase;color:#fff;` +
			`background:${color};pointer-events:none;font-family:inherit;}`;
		document.head.appendChild(style);

		const banner = document.createElement("div");
		banner.id = BANNER_ID;
		banner.textContent = info.label;
		document.body.appendChild(banner);

		const spacer = document.createElement("div");
		spacer.id = `${BANNER_ID}-spacer`;
		document.body.appendChild(spacer);
	}

	function init() {
		if (window.frappe && frappe.boot && frappe.boot.platform_env) {
			render(frappe.boot.platform_env);
			return;
		}
		// Guest / website / login pages have no boot data — ask the server once.
		if (window.frappe && frappe.call) {
			frappe
				.call({ method: "avs_platform.boot.get_platform_env" })
				.then((r) => render(r && r.message))
				.catch(() => {});
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
